<template>
  <sc-taginput
    v-model="listTags"
    :data="filteredTags"
    field="description"
    icon="tags"
    type="is-primary"
    placeholder="Adicionar novo marcador"
    @add="add"
    @remove="remove"
    @typing="getFilteredTags"
    autocomplete>

    <template slot-scope="props">
      <div class="tags">
        <sc-recon-marker
          :marker="props.option"
          :custom-description="getValue(props.option.description)"
          size="is-medium" />
      </div>
    </template>

    <template slot="empty">
      Nenhum marcador encontrado
    </template>
  </sc-taginput>
</template>

<script>
  import { ScTaginput } from '@intelipost-js/secure-components';
  import ScReconMarker from '../../components/sc-recon-marker/ScReconMarker';
  import { createNamespacedHelpers } from 'vuex';

  const { mapState, mapActions } = createNamespacedHelpers('recon');

  export default {
    name: 'sc-recon-markers-input',
    props: {
      tags: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        listTags: [],
        filteredTags: [],
        filteredText: null,
      };
    },
    watch: {
      tags() {
        this.listTags = [...this.tags];
      },
    },
    computed: {
      ...mapState([
        'markers',
      ]),
    },
    methods: {
      ...mapActions([
        'getMarkers',
      ]),
      add(tag) {
        this.$emit('add', tag);
      },
      remove(tag) {
        this.$emit('remove', tag);
      },
      getFilteredTags(text) {
        this.filteredText = text;
        this.filteredTags = [];

        if (this.filteredText) {
          this.filteredTags = this.markers
            .filter(marker => !this.tags.find(tag => tag.id === marker.id))
            .filter(marker => marker.description
              .toString()
              .toLowerCase()
              .indexOf(text.toLowerCase()) >= 0);
        }
      },
      getValue(value) {
        const regex = new RegExp(`(${this.filteredText})`, 'gi');

        return value.replace(regex, '<b>$1</b>');
      },
    },
    beforeMount() {
      this.getMarkers();
    },
    components: {
      ScTaginput,
      ScReconMarker,
    },
  };
</script>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/components/sc-recon-markers-input/ScReconMarkersInput.vue?d427d0fc